import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, SimpleChange } from '@angular/core';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnChanges {
  @Input() show = true;
  @Input() size = 'md';
  @Input() x = true;
  @Output() onClose = new EventEmitter<void>();

  constructor() {
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    const show = changes.show;
    if (show && show.currentValue) {
      window.addEventListener('keydown', this.handleKeyDown);
    } else {
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  }

  close() {
    this.onClose.emit();
  }

  disableClick(event: any): boolean {
    event.stopPropagation();
    return true;
  }

  handleKeyDown(event: any) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}
